import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchEnumValues, fetchUserByEmail } from '@services/commonService';

import ApiClient from '@lib/apiClient';

const CreateTeamPopUp = ({ onClose, brandId, seledtedData, editId }) => {
	const [teamDetails, setTeamDetails] = useState({ brandId: brandId, ...seledtedData });
	const [isError, setIsError] = useState(null);
	const [departments, setDepartments] = useState([]);
	const [, setUserList] = useState([]);
	const [searchName, setSearchName] = useState('');
	const dispatch = useDispatch();
	const isGlobalLoading = useSelector((store) => store.loaderStore);

	const fetchDepartments = async () => {
		const departmentsData = await fetchEnumValues('info.nitex.app.user.BrandDepartment?sorted=true');
		setDepartments(departmentsData);
	};

	const searchUserByEmail = async () => {
		let params = `?page=0&notTeamAssigned=true&size=100&brandId=${brandId}&email=${searchName}`;
		let response = await fetchUserByEmail(params);
		return response?.map((item) => ({
			value: item.id,
			label: item.name
		}));
	};

	useEffect(() => {
		fetchDepartments();
	}, []);

	const onChangeTeamDetails = (e) => {
		setTeamDetails({ ...teamDetails, [e.target.name]: e.target.value });
	};

	const onChangeMultiSelect = (selected, fieldName) => {
		setTeamDetails((prev) => ({
			...prev,
			[fieldName]: selected?.map((item) => item?.value)
		}));
	};

	// const loadOptions = async (inputValue = '') => {
	// 	let response = await searchUserByEmail(inputValue);
	// 	return response;
	// };

	const promiseOptions = () =>
		new Promise((resolve) => {
			setTimeout(() => {
				setUserList(resolve(searchUserByEmail()));
			}, 1000);
		});

	const styles = {
		control: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		}),
		menu: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		})
	};

	const checkIsValid = () => {
		let isValid = true;
		const updatedErrors = {};

		if (!teamDetails?.name) {
			isValid = false;
			updatedErrors.nameError = 'required';
		}

		if (!teamDetails?.brandDepartment) {
			isValid = false;
			updatedErrors.departmentError = 'required';
		}

		setIsError((prevErrors) => ({ ...prevErrors, ...updatedErrors }));
		return isValid;
	};

	const onAdd = async () => {
		try {
			if (!checkIsValid()) return;
			dispatch(openLoader());
			await ApiClient.POST('getTeamBrands', teamDetails, `add`);
			setIsError(null);
			onClose();
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onEdit = async () => {
		try {
			if (!checkIsValid()) return;
			dispatch(openLoader());
			await ApiClient.PUT('getTeamBrands', teamDetails, `${editId}`);
			setIsError(null);
			onClose();
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	return (
		<ModalContainer onCloseModal={onClose}>
			<div className="common-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0"> {editId ? 'Edit' : 'Create team'}</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group ">
									<label htmlFor="brand-name">Team name*</label>
									<input
										type="text"
										autoComplete="off"
										name="name"
										value={teamDetails?.name}
										onChange={(e) => onChangeTeamDetails(e)}
									/>
									{isError?.nameError && (
										<span className="error">{isError?.nameError}</span>
									)}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label>Department *</label>
									<select
										name="brandDepartment"
										value={teamDetails?.brandDepartment}
										onChange={onChangeTeamDetails}
										className="bg-gray-light"
									>
										<option>Select department</option>
										{departments?.map((item) => {
											return (
												<option key={item.id} value={item.constant}>
													{item.name}
												</option>
											);
										})}
									</select>
									{isError?.departmentError && (
										<span className="error">{isError?.departmentError}</span>
									)}
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="operationalZone">Select Client</label>
									<AsyncSelect
										styles={styles}
										onInputChange={(v) => setSearchName(v)}
										onChange={(selected) => onChangeMultiSelect(selected, 'userIds')}
										isMulti
										cacheOptions
										defaultOptions
										loadOptions={promiseOptions}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button
							className="button size32 ml-2"
							disabled={isGlobalLoading}
							onClick={() => {
								editId ? onEdit() : onAdd();
							}}
						>
							{editId ? 'Update' : 'Create'}
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default CreateTeamPopUp;
